if (!rtAPI) var rtAPI = {
    lastHeader: {}
};
if (!rtAPI.security) rtAPI.security = {
    dialogMode: '',
    changePasswordMode: '',
    initRun: false,
    initPasswordAndMFAManagmentRun: false,
    initSecurityDialogRun: false,
    initialising: false
};

//#region Vars

rtAPI.security.pnl = {
    login: 'pnlLogin',
    lostPassword: 'pnlLostPassword',
    lostUsername: 'pnlLostUsername',
    resendAuthEmail: 'pnlResendAuthEmail',
    tFASelect: 'pnl2FASelect',
    tFASelectOptions: 'pnl2FASelectOptions',
    tFACode: 'pnl2FACode',
    tFAMemorableData: 'pnl2FAMemorableData',
    tFAMemorableDataFields: 'pnl2FAMemorableDataFields',
    tFAHardwareKey: 'pnl2FAHardwareKey',
    dialog: 'pnlSecurityDialog_Overlay',
    dialogFrame: 'pnlSecurityDialog',
    dialogTitle: 'pnlSecurityDialog_Title',
    dialogFields: 'pnlSecurityDialog_Fields',
    dialogMessages: 'pnlSecurityDialog_Messages',
    dialogButtons: 'pnlSecurityDialog_Buttons',
    logout: 'pnlLogout',
    updatePassword: 'pnlUpdatePassword'
};

rtAPI.security.fd = {
    login: 'fdPWLogin',
    password: 'fdPWPassword',
    loginLost: 'fdPWLoginLost',
    loginLostEmail: 'fdPWLoginLostEmail',
    manageTFA: 'fdManageTFA',
    resendAuthEmail: 'fdResendAuthEmail',
    authenticationMethod: 'fdAuthenticationMethod',
    authenticationCode: 'fdAuthenticationCode',
    oldPassword: 'fdOldPassword',
    newPassword: 'fdNewPassword',
    retypeNewPassword: 'fdRetypeNewPassword',
    tFAUpdatePassword: ''
};

rtAPI.security.errorMessage = {
    login: 'Please enter your login',
    password: 'Please enter your password',
    loginLostEmail: 'Please enter your registered email address',
    loginLost: 'Please enter your login',
    resendAuthEmail: 'Please enter the email address you are trying to authorise',
    authenticationCode: 'Please enter the authentication code from the email or SMS you were sent',
    oldPassword: 'Please enter your current password',
    newPassword: 'Please enter a new password',
    retypeNewPassword: 'Please retype your new password',
    retypeNewPasswordMustMatch: 'Your retyped new password must match your new password',
    weakPassword: 'Your new password does not meet the minimum password strength'
};

rtAPI.security.btn = {
    login: 'btnLogin',
    loginSSO: 'btnLoginSSO',
    lostPassword: 'btnLostPassword',
    lostUsername: 'btnLostUsername',
    resendAuthEmail: 'btnResendAuthEmail',
    getPassword: 'btnGetPassword',
    getPasswordCancel: 'btnGetPasswordCancel',
    getUsername: 'btnGetUsername',
    getUsernameCancel: 'btnGetUsernameCancel',
    resendAuthEmailSend: 'btnResendAuthEmailSend',
    resendAuthEmailCancel: 'btnResendAuthEmailCancel',
    tFASelectCancel: 'btn2FASelectCancel',
    tFAAuthenticateCodeSend: 'btnAuthenticateCodeSend',
    tFAAuthenticateCodeCancel: 'btnAuthenticateCodeCancel',
    tFAHardwareKeyRegister: 'btnHardwareKeyRegister',
    tFAHardwareKeyRetry: 'btnHardwareKeyRetry',
    tFAHardwareKeyCancel: 'btnHardwareKeyCancel',
    tFAMemorableDataSend: 'btnMemorableDataSend',
    tFAMemorableDataCancel: 'btnMemorableDataCancel',
    tFAManageHardwareKeyAdd: 'btn2FAManageHardwareKeyAdd',
    tFAManageUpdate: 'btn2FAManageUpdate',
    tFAManageBack: 'btn2FAManageBack',
    tFAManageClose: 'btn2FAManageClose',
    tFAManageButtons: {},
    logout: 'btnLogout',
    updatePassword: 'btnUpdatePassword',
    updatePasswordClose: 'btnUpdatePasswordClose',
    showUpdatePassword: 'btnShowUpdatePassword'
};

rtAPI.security.panelUpdateCallback = null;
rtAPI.security.handle = {};
rtAPI.security.call = {};
rtAPI.security.tFASelectModeTriggered = false;
rtAPI.security.showTFAManagement = false;
rtAPI.security.renderedTFAOptions = '';
rtAPI.security.tFAData = {};
rtAPI.security.samePageLogin = false;
rtAPI.security.enableTFAManagement = true;
rtAPI.security.enableGetUsername = true;
rtAPI.security.enableAccountActivation = true;
rtAPI.security.enableGetPassword = true;
rtAPI.security.fireTFAHardwareKeyLoginWhenSelected = true;
rtAPI.security.dialogAutoClose = false;
rtAPI.security.lastPanelMode = '';

//#endregion

//#region Init Login and MFA

rtAPI.security.init = async function () {
    rtAPI.security.initialising = true;
    if (rtAPI.security.initRun) {
        await rtAPI.security.autoLoginUsingTempPassword();
        rtAPI.security.initialising = false;
        return;
    }
    rtAPI.security.initRun = true;

    //Login
    rtAPI.initElement('security.pnl', 'login', 'pnl-login', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'login', 'cpc-pw-login-input', null, 'requiredGroupLogin');
    rtAPI.initElement('security.fd', 'password', 'cpc-pw-password-input', null, 'requiredGroupLogin');
    rtAPI.initElement('security.fd', 'manageTFA', 'cpc-manage-tfa-input');
    rtAPI.initElement('security.btn', 'login', 'btn-login', 'button');
    rtAPI.initElement('security.btn', 'loginSSO', 'btn-login-SSO', 'button');
    rtAPI.initElement('security.btn', 'lostPassword', 'btn-lost-password');
    rtAPI.initElement('security.btn', 'lostUsername', 'btn-lost-username');
    rtAPI.initElement('security.btn', 'resendAuthEmail', 'btn-resend-auth-email');
    rtAPI.clickElement(this.btn.login, this.handle.login);
    rtAPI.clickElement(this.btn.loginSSO, this.handle.loginSSO);
    rtAPI.clickElement(this.btn.lostPassword, this.handle.showLostPassword);
    rtAPI.clickElement(this.btn.lostUsername, this.handle.showLostUsername);
    rtAPI.clickElement(this.btn.resendAuthEmail, this.handle.showResendAuthEmail);
    this.fd.login.addElementToTabTo(this.fd.password);
    this.fd.password.addButtonToClick(this.btn.login);


    //Lost Password
    rtAPI.initElement('security.pnl', 'lostPassword', 'pnl-lost-password', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'loginLost', 'cpc-lost-password-input', null, 'requiredGroupLostPassword');
    rtAPI.initElement('security.btn', 'getPassword', 'btn-get-password', 'button');
    rtAPI.initElement('security.btn', 'getPasswordCancel', 'btn-get-password-cancel', 'button');
    if (rtAPI.security.enableGetPassword) {
        rtAPI.clickElement(this.btn.getPassword, this.handle.getLostPassword);
        rtAPI.clickElement(this.btn.getPasswordCancel, this.handle.showLoginPanel);
        this.fd.loginLost.addButtonToClick(this.btn.getPassword);
    }

    //Lost Username
    rtAPI.initElement('security.pnl', 'lostUsername', 'pnl-lost-username', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'loginLostEmail', 'cpc-lost-username-input', null, 'requiredGroupLostUsername');
    rtAPI.initElement('security.btn', 'getUsername', 'btn-get-username', 'button');
    rtAPI.initElement('security.btn', 'getUsernameCancel', 'btn-get-username-cancel', 'button');
    if (rtAPI.security.enableGetUsername) {
        rtAPI.clickElement(this.btn.getUsername, this.handle.getLostUsername);
        rtAPI.clickElement(this.btn.getUsernameCancel, this.handle.showLoginPanel);
        this.fd.loginLostEmail.addButtonToClick(this.btn.getUsername);
    }

    //Resend Auth Email Panel
    rtAPI.initElement('security.pnl', 'resendAuthEmail', 'pnl-resend-auth-email', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'resendAuthEmail', 'cpc-resend-auth-email-input', null, 'requiredGroupResendAuthEmail');
    rtAPI.initElement('security.btn', 'resendAuthEmailSend', 'btn-resend-auth-email-send', 'button');
    rtAPI.initElement('security.btn', 'resendAuthEmailCancel', 'btn-resend-auth-email-cancel', 'button');
    if (rtAPI.security.enableAccountActivation) {
        rtAPI.clickElement(this.btn.resendAuthEmailSend, this.handle.resendAuthEmailSend);
        rtAPI.clickElement(this.btn.resendAuthEmailCancel, this.handle.showLoginPanel);
        this.fd.resendAuthEmail.addButtonToClick(this.btn.resendAuthEmailSend);
    }

    //2FA Select Panel
    rtAPI.initElement('security.pnl', 'tFASelect', 'pnl-two-factor-authentication-select', 'pnlSecurity');
    rtAPI.initElement('security.pnl', 'tFASelectOptions', 'pnl-two-factor-authentication-select-options');
    rtAPI.initElement('security.btn', 'tFASelectCancel', 'btn-two-factor-authentication-select-cancel', 'button');
    rtAPI.clickElement(this.btn.tFASelectCancel, this.handle.tFAAuthenticateCancel);

    //2FA Code Panel
    rtAPI.initElement('security.pnl', 'tFACode', 'pnl-auth-code', 'pnlSecurity');
    rtAPI.initElement('security.fd', 'authenticationCode', 'cpc-authentication-code-input', null, 'requiredGroupAuthCode');
    rtAPI.initElement('security.btn', 'tFAAuthenticateCodeSend', 'btn-authentication-code-send', 'button');
    rtAPI.initElement('security.btn', 'tFAAuthenticateCodeCancel', 'btn-authentication-method-code-cancel', 'button');
    rtAPI.clickElement(this.btn.tFAAuthenticateCodeSend, this.handle.tFAAuthenticateCodeSend);
    rtAPI.clickElement(this.btn.tFAAuthenticateCodeCancel, this.handle.tFAAuthenticateCancel);
    this.fd.authenticationCode.addButtonToClick(this.btn.tFAAuthenticateCodeSend);

    //2FA Memorable Data Panel
    rtAPI.initElement('security.pnl', 'tFAMemorableData', 'pnl-memorable-data', 'pnlSecurity');
    rtAPI.initElement('security.pnl', 'tFAMemorableDataFields', 'pnl-memorable-data-fields');
    rtAPI.initElement('security.btn', 'tFAMemorableDataSend', 'btn-authentication-code-send', 'button');
    rtAPI.initElement('security.btn', 'tFAMemorableDataCancel', 'btn-authentication-method-code-cancel', 'button');
    rtAPI.clickElement(this.btn.tFAMemorableDataSend, this.handle.tFAMemorableDataSend);
    rtAPI.clickElement(this.btn.tFAMemorableDataCancel, this.handle.tFAAuthenticateCancel);

    //2FA Hardware Key Panel
    rtAPI.initElement('security.pnl', 'tFAHardwareKey', 'pnl-hardware-key', 'pnlSecurity');
    rtAPI.initElement('security.btn', 'tFAHardwareKeyRegister', 'btn-hardware-key-register', 'button');
    rtAPI.initElement('security.btn', 'tFAHardwareKeyRetry', 'btn-hardware-key-retry', 'button');
    rtAPI.initElement('security.btn', 'tFAHardwareKeyCancel', 'btn-hardware-key-cancel', 'button');
    rtAPI.clickElement(this.btn.tFAHardwareKeyRegister, this.handle.tFAHardwareKeyRegister);
    rtAPI.clickElement(this.btn.tFAHardwareKeyRetry, this.handle.tFAHardwareKeyRetry);
    rtAPI.clickElement(this.btn.tFAHardwareKeyCancel, this.handle.tFAAuthenticateCancel);


    //Logged in
    rtAPI.initElement('security.pnl', 'logout', 'pnl-logout', 'pnlSecurity');
    rtAPI.initElement('security.btn', 'logout', 'btn-logout', 'button');
    rtAPI.clickElement(this.btn.logout, this.handle.logout);

    var result = await rtAPI.security.call.getCurrentUser();
    await rtAPI.security.updatePanels(result);

    await rtAPI.security.initPasswordAndMFAManagment();
    rtAPI.security.initialising = false;
    //rtAPI.security.initSecurityDialog();
    //rtAPI.security.initUpdatePassword();

    //await rtAPI.security.autoLoginUsingTempPassword();
}

rtAPI.security.initPasswordAndMFAManagment = async function () {
    rtAPI.security.initialising = true;
    if (rtAPI.security.initPasswordAndMFAManagmentRun) {
        await rtAPI.security.autoLoginUsingTempPassword();
        rtAPI.security.initialising = false;
        return;
    }
    rtAPI.security.initPasswordAndMFAManagmentRun = true;
    rtAPI.security.initSecurityDialog();
    //rtAPI.security.initUpdatePassword();

    await rtAPI.security.autoLoginUsingTempPassword();
    rtAPI.security.initialising = false;
}

//fdUsername=MFA-T@testmail.rocktime.co.uk&fdTemporaryPassword=cba334f8-30b6-4589-b1ba-baa5009c6d12&fdReturnURL=%2F
rtAPI.security.autoLoginUsingTempPassword = async function () {
    //debugger;
    var fdUsername = rtAPI.query.params.get('fdUsername');
    var fdTemporaryPassword = rtAPI.query.params.get('fdTemporaryPassword');
    var samePageLogin = (rtAPI.isEmptyString(rtAPI.query.params.get('fdReturnURL')));
    if (rtAPI.isEmptyString(fdUsername) || rtAPI.isEmptyString(fdTemporaryPassword)) return;

    var result = await this.call.autoLoginUsingTempPassword(fdUsername, fdTemporaryPassword, samePageLogin);
    await rtAPI.security.updatePanels(result);
}


//#endregion

//#region Init Security Dialog

rtAPI.security.initSecurityDialog = function (forceShow, autoClose, message) {
    //if (!rtAPI.security.enableTFAManagement) return

    rtAPI.security.createSecurityDialog();
    if (rtAPI.security.initSecurityDialogRun) return;
    rtAPI.security.initSecurityDialogRun = true;


    rtAPI.initElement('security.pnl', 'dialog', 'pnl-dialog', 'security-dialog-overlay pnlSecurity');
    rtAPI.initElement('security.pnl', 'dialogFrame', 'pnl-dialog-frame');
    rtAPI.initElement('security.pnl', 'dialogFields', 'pnl-dialog-fields', 'security-dialog-content-fields');
    rtAPI.initElement('security.pnl', 'dialogTitle', 'pnl-dialog-title', 'security-dialog-content-title');
    rtAPI.initElement('security.pnl', 'dialogMessages', 'pnl-dialog-messages', 'security-dialog-content-messages');
    rtAPI.initElement('security.pnl', 'dialogButtons', 'pnl-dialog-buttons', 'security-dialog-content-buttons');

    rtAPI.security.showSecurityDialog(forceShow, autoClose, message);
    rtAPI.security.pnl.dialog.addDiv({ 'sid': 'api-security-initalised', className: 'aspNetHidden' });
}

rtAPI.security.createSecurityDialog = function () {
    var dialog = document.getElementById('pnlSecurityDialog_Overlay');
    if (dialog) return;

    dialog = document.createElement("div");
    dialog.extendDOM();
    dialog.id = 'pnlSecurityDialog_Overlay';
    document.body.insertBefore(dialog, document.body.firstChild);

    //dialog = securityDialogConstrutionDiv.addDiv({ 'id': 'pnlSecurityDialog_Overlay', 'className': 'security-dialog-overlay' });
    //dialog.style.display = 'none';
    //document.insertBefore(dialog);

    var securityDialog = dialog.addDiv({ 'id': 'pnlSecurityDialog' });
    var securityDialogContent = securityDialog.addDiv({ 'className': 'security-dialog-content' });
    securityDialogContent.addH2(null, null, 'pnlSecurityDialog_Title');
    securityDialogContent.addDiv({ 'id': 'pnlSecurityDialog_Fields' });
    securityDialogContent.addDiv({ 'id': 'pnlSecurityDialog_Messages' });
    securityDialogContent.addDiv({ 'id': 'pnlSecurityDialog_Buttons' });
}

rtAPI.security.addDefaultSecurityDialogButtons = function (showBack, showClose) {
    var defaultButtons = document.getElementById('pnlSecurityDialog_Buttons');
    if (!defaultButtons) return;
    //this.addButton(id, text, clickEventHandler, hidden, className)
    this.btn.tFAManageBack = defaultButtons.addButton('btn2FAManageBack', rtAPI.security.tFAData.text.btnBack, this.handle.tFAManageBack, false, 'button', 'btn-manage-back');
    this.btn.tFAManageClose = defaultButtons.addButton('btn2FAManageClose', rtAPI.security.tFAData.text.btnClose, this.handle.tFAManageClose, false, 'button', 'btn-manage-close');
    rtAPI.security.showDefaultSecurityDialogButtons(showBack, showClose);
}

rtAPI.security.dialogModeIs = function (mode) {
    if (rtAPI.security.dialogMode == mode) return true;
    rtAPI.security.dialogMode = mode;
    return false;
}

rtAPI.security.showDefaultSecurityDialogButtons = function (showBack, showClose) {
    rtAPI.displayElement(this.btn.tFAManageBack, showBack ? 'inline-block' : 'none');
    rtAPI.displayElement(this.btn.tFAManageClose, showClose ? 'inline-block' : 'none');

}

rtAPI.security.showSecurityDialog = function (show, autoClose, message, width, height) {
    //rtAPI.displayElement(rtAPI.security.pnl.dialog, show);
    if (show) rtAPI.security.openSecurityDialog(width, height)
    else rtAPI.security.hideSecurityDialog();

    var cursor = 'inherit';
    if (!show) {
        autoClose = false;
        message = '';
    }
    if (autoClose) cursor = 'pointer';
    rtAPI.security.dialogAutoClose = autoClose;
    rtAPI.security.pnl.dialog.style.cursor = cursor;

    rtAPI.displayElement(rtAPI.security.pnl.dialogMessages, (rtAPI.isNothing(message)));
    rtAPI.security.pnl.dialogMessages.textContent = message;
}

rtAPI.security.resizeSecurityDialog = function (width, height) {
    if (width != undefined) rtAPI.security.pnl.dialogFrame.style.width = width;
    if (height != undefined) rtAPI.security.pnl.dialogFrame.style.height = height;
}

rtAPI.security.openSecurityDialog = function (width, height) {
    this.resizeSecurityDialog(width, height);
    rtAPI.security.dialogAutoClose = false;
    rtAPI.security.pnl.dialog.style.cursor = 'inherit';
    //rtAPI.displayElement(rtAPI.security.pnl.dialog, true);
    //rtAPI.security.pnl.dialog.style.display = "flex";
    document.body.classList.add("security-dialog-lock");
    rtAPI.messages.target = 'pnlSecurityDialog_Messages';
    rtAPI.messages.clear();
}

rtAPI.security.clearSecurityDialog = function () {
    rtAPI.security.pnl.dialogTitle.innerHTML = '';
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.pnl.dialogMessages.innerHTML = '';
    rtAPI.security.pnl.dialogButtons.innerHTML = '';
    rtAPI.security.pnl.dialogFrame.style.width = 'initial';
    rtAPI.security.pnl.dialogFrame.style.height = 'initial';
    rtAPI.displayElement(rtAPI.security.pnl.dialogMessages, true);
    rtAPI.messages.clear();
}

rtAPI.security.hideSecurityDialog = function () {
    //debugger;
    rtAPI.security.dialogAutoClose = false;
    rtAPI.security.pnl.dialog.style.cursor = 'inherit';
    document.body.classList.remove("security-dialog-lock");
    rtAPI.security.dialogMode = '';
    rtAPI.messages.target = '';
    rtAPI.messages.targetSuffix = '';
    this.clearSecurityDialog();
}

//#endregion

//#region Update Password

rtAPI.security.initMFM = function () {
    if (rtAPI.security.initMFM) return;
    rtAPI.security.initMFM = true;
    rtAPI.security.initSecurityDialog();
    return;

}
//#endregion

//#region Update Password

rtAPI.security.initUpdatePassword = function () {
    if (rtAPI.security.initUpdatePasswordRun) return;
    rtAPI.security.initUpdatePasswordRun = true;
    rtAPI.security.initSecurityDialog();
    //rtAPI.initElement('security.pnl', 'updatePassword', 'pnl-update-password', 'pnlSecurity');
    //rtAPI.initElement('security.fd', 'oldPassword', 'cpc-pw-old-password-input', null, 'requiredGroupUpdatePassword');
    //rtAPI.initElement('security.fd', 'newPassword', 'cpc-pw-new-password-input', null, 'requiredGroupUpdatePassword');
    //rtAPI.initElement('security.fd', 'retypeNewPassword', 'cpc-pw-retype-new-password-input', null, 'requiredGroupUpdatePassword');
    //rtAPI.initElement('security.btn', 'updatePassword', 'btn-update-password', 'button');
    //rtAPI.initElement('security.btn', 'updatePasswordClose', 'btn-update-password-close', 'button');
    //rtAPI.initElement('security.btn', 'showUpdatePassword', 'btn-show-update-password', 'button');
    //rtAPI.clickElement(this.btn.updatePassword, this.handle.updatePassword);
    //rtAPI.clickElement(this.btn.updatePasswordClose, this.handle.updatePasswordClose);
    //rtAPI.clickElement(this.btn.showUpdatePassword, this.handle.showUpdatePassword);
    //rtAPI.security.fd.newPassword.addEventListener('input', this.handle.inputPasswordField);

}

//#endregion

//#region Misc

rtAPI.security.clearFields = function () {

    for (const propertyName in rtAPI.security.fd) {
        var item = rtAPI.security.fd[propertyName];
        if (item == undefined) continue;
        switch (item.type) {
            case 'checkbox':
                item.checked = false;
                break;

            default:// text
                item.value = '';
                break;

        }
    }
}

//#endregion

//#region Buttons

rtAPI.security.bindShowMFMButton = function (btn) {
    rtAPI.security.showMFMButton = btn;
    rtAPI.clickElement(btn, rtAPI.security.handle.showMFM);
}

rtAPI.security.bindShowMFMButtonById = function (btnId) {
    rtAPI.security.bindShowMFMButton(document.getElementById(btnId));
}

rtAPI.security.bindShowUpdatePasswordButton = function (btn) {
    rtAPI.security.initSecurityDialog();
    rtAPI.security.showUpdatePasswordButton = btn;
    rtAPI.clickElement(btn, rtAPI.security.handle.showUpdatePassword);
}

rtAPI.security.bindShowUpdatePasswordButtonById = function (btnId) {
    rtAPI.security.bindShowUpdatePasswordButton(document.getElementById(btnId));
}

//#endregion

//#region 2FAOption 

rtAPI.security.get2FAOption = function (method) {
    for (const option of rtAPI.security.tFAData.options) {
        if (option.method == method) return option;
    }
    console.error(`Cannot find 2FA method ${method}`);
}

rtAPI.security.get2FAOptionField = function (id) {
    if (rtAPI.security.tFAData.password.id == id) return rtAPI.security.tFAData.password;
    for (const option of rtAPI.security.tFAData.options) {
        for (const field of option.fields) {
            if (field.id == id) return field;
        }
    }
    console.error(`Cannot find 2FA field ${id}`);
}

//#endregion
